<template>
  <!--Banner Form Content Start-->
  <form @submit.prevent="submit">
    <div class="trip-type-frm">
      <!-- Name -->
      <div class="field-outer">
        <span class="fas fa-user"></span>
        <input
          type="text"
          name="name"
          placeholder="Name"
          v-model.trim="$v.booking.name.$model"
          :class="{ 'is-invalid': $v.booking.name.$error,'is-valid': !$v.booking.name.$error}"
        />
      </div>
      <div class="invalid-feedback" v-if="!$v.booking.name.required && submitted">Name is required</div>
      <div
        class="invalid-feedback"
        v-if="!$v.booking.name.minLength && submitted"
      >Name must have at least {{$v.booking.name.$params.minLength.min}} letters.</div>

      <!-- Phone Number -->
      <div class="field-outer">
        <span class="fas fa-phone"></span>
        <input
          type="text"
          name="phoneNumber"
          placeholder="Phone Number"
          v-model.trim="$v.booking.phoneNumber.$model"
          :class="{ 'is-invalid': $v.booking.phoneNumber.$error , 'is-valid': !$v.booking.phoneNumber.$error }"
        />
      </div>
      <!-- Error Start -->
      <div
        class="invalid-feedback"
        v-if="!$v.booking.phoneNumber.required && submitted"
      >Phone Number is required</div>
      <div
        class="invalid-feedback"
        v-if="!$v.booking.phoneNumber.strongPhoneNumber&&$v.booking.phoneNumber.required && submitted"
      >
        Phone Number is Invalid.
        <br />Only international Number Pattern.
        <br />+923231234567 or 3231234567
      </div>
      <!-- Error End -->

      <!-- Email -->
      <div class="field-outer">
        <span class="fas fa-envelope"></span>
        <input
          type="text"
          name="emaill"
          placeholder="Email"
          v-model.trim="$v.booking.email.$model"
          :class="{ 'is-invalid': $v.booking.email.$error ,'is-valid': !$v.booking.email.$error }"
        />
      </div>

      <!-- Error Start -->
      <div class="invalid-feedback" v-if="!$v.booking.email.required && submitted">Email is required</div>
      <div
        class="invalid-feedback"
        v-if="!$v.booking.email.email&&$v.booking.email.required && submitted"
      >Invalid Email</div>
      <!-- Error End -->

      <!-- Pickup  -->
      <div class="field-outer">
        <span class="fas fa-search"></span>

        <vue-google-autocomplete
          id="pickUpAddress"
          class="form-control autoComplete"
          placeholder="Pick Up Address"          
          v-on:placechanged="getPickupAddressData"
        ></vue-google-autocomplete>
        <!-- <input
          type="text"
          name="pickUp"
          placeholder="Pickup Location"
          v-model.trim="$v.booking.pickupAddress.$model"
          :class="{ 'is-invalid': $v.booking.pickupAddress.$error,'is-valid': !$v.booking.pickupAddress.$error }"
        />-->
      </div>
      <!-- Error Start -->
      <!-- <div
        class="invalid-feedback"
        v-if="!$v.booking.pickupAddress.required && submitted"
      >Pick Up Address is required</div> -->
      <!-- Error End -->

      <!-- Drop Off -->
      <div class="field-outer">
        <span class="fas fa-search"></span>
        
        <vue-google-autocomplete
          id="dropOffAddress"
          class="form-control"
          placeholder="Drop Off Address"
          v-on:placechanged="getDropOffAddressData"
        ></vue-google-autocomplete>
        <!-- <input
          type="text"
          name="drop_loc"
          placeholder="Drop Off Location"
          v-model.trim="$v.booking.dropOffAddress.$model"
          :class="{ 'is-invalid': $v.booking.dropOffAddress.$error ,'is-valid': !$v.booking.dropOffAddress.$error}"
        /> -->
      </div>
      <!-- Error Start -->
      <!-- <div
        class="invalid-feedback"
        v-if="!$v.booking.dropOffAddress.required && submitted"
      >Drop Off Address is required</div> -->
      <!-- Error End -->

      <!-- Vehicle Type -->
      <div class="field-outer">
        <span class="fas fa-car"></span>
        <select
          name="vehicleTypeId"
          v-model.trim="$v.booking.vehicleTypeId.$model"
          :class="{ 'is-invalid': $v.booking.vehicleTypeId.$error ,'is-valid': !$v.booking.vehicleTypeId.$error}"
        >
          <option value="0">Select Car Type</option>
          <option
            :value="vehicleType.id"
            v-for="(vehicleType,key) in vehicleTypes"
            :key="key"
          >{{vehicleType.title}}</option>
        </select>
      </div>
      <!-- Error Start -->
      <div
        class="invalid-feedback"
        v-if="!$v.booking.vehicleTypeId.minValue && submitted"
      >Select Vehicle Type</div>
      <!-- Error End -->
    </div>

    <!-- PickUp Date -->
    <div class="date-time-picker">
      <VueCtkDateTimePicker v-model.trim="$v.booking.pickupDate.$model" label="Select PickUp Date" />
    </div>
    <!-- Error Start -->
    <div
      class="invalid-feedback"
      v-if="!$v.booking.pickupDate.required && submitted"
    >Pick Up Date is required</div>
    <!-- Error End -->
    <div class="trip-type-frm">
      <button type="submit" class="search-btn" :disabled="submitStatus === 'PENDING'">
        Book Now
        <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="trip-type-frm">
      <p
        class="typo__p"
        v-if="submitStatus === 'OK'"
      >Thanks for Booking our team will respond your request soon!</p>
      <p class="invalid-feedback" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</p>
      <p
        class="invalid-feedback"
        v-if="submitStatus === 'SERVER_ERROR'"
      >An error occurred while sending Request.</p>
      <p class v-if="submitStatus === 'PENDING'">Sending...</p>
    </div>
  </form>

  <!--Banner Form Content End-->
</template>
<script>
import {
  required,
  minLength,
  between,
  email,
  helpers,
  minValue
} from "vuelidate/lib/validators";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import mailer from "../../services/mailer.service";
import firebase from "firebase";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import tabular from "../../services/tabular.service";
export default {
  components: { VueCtkDateTimePicker, VueGoogleAutocomplete },
  data() {
    return {
      db: null,
      submitted: false,
      submitStatus: null,
      vehicleTypes: [
        {
          id: 1,
          title: "Saloon = 4 Passengers x Hand Luggage Only"
        },
        {
          id: 2,
          title: "Estate = 4 Passengers x 4 S/cases"
        },
        {
          id: 3,
          title: "MPV 6 Seater = 6 Passengers x 4 S/cases"
        }
      ],
      booking: {
        name: "",
        email: "",
        phoneNumber: "",
        pickupAddress: "",
        dropOffAddress: "",
        pickupDate: new Date(),
        pickupTime: "",
        dropOffDate: new Date(),
        returnDate: new Date(),
        vehicleTypeId: 0,
        returnTime: "",
        passengers: 4,
        luggage: 1,
        childSeat: false,
        specialInstructions: ""
      }
    };
  },
  validations: {
    booking: {
      name: {
        required,
        minLength: minLength(3)
      },
      phoneNumber: {
        required,
        strongPhoneNumber(val) {
          return /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/.test(
            val
          );
        }
      },
      email: {
        required,
        email
      },
      // pickupAddress: {
      //   required
      // },
      // dropOffAddress: {
      //   required
      // },
      vehicleTypeId: {
        minValue: minValue(1)
      },
      pickupDate: {
        required
      }
    }
  },
  methods: {
    submit() {
      console.clear();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } 
      else if(this.booking.pickupAddress==""||this.booking.dropOffAddress==""){
        this.submitStatus = "ERROR";
      }
      else {
        // do your submit logic here
        this.submitStatus = "PENDING";
        mailer
          .send({to: this.db.mailer.receiver,from: this.db.mailer.sender,subject: "New One Way Booking",html: tabular.oneWayGenerate(this.booking,this.vehicleTypes)})
          .then(res => {
            this.submitStatus = "OK";
          })
          .catch(err => {
            this.submitStatus = "SERVER_ERROR";
          });
      }
    },
    getPickupAddressData: function(addressData, placeResultData, id) {
      console.clear();
      this.booking.pickupAddress = placeResultData.formatted_address;
    },
     getDropOffAddressData: function(addressData, placeResultData, id) {
      console.clear();
      this.booking.dropOffAddress = placeResultData.formatted_address;
    }
  },
  created() {
    let that = this;
    var ref = firebase.database().ref();
    ref.on(
      "value",
      function(snapshot) {
        that.db = snapshot.val();
        // console.log(that.db);
      },
      function(error) {
        console.log("Error: " + error.code);
      }
    );
  }
};
</script>
<style scoped>
.date-time-picker {
  background-color: rgb(246, 246, 246);
  float: left;
  width: 100%;
}
select {
  width: 100%;  
  height: 45px;
  padding: 10px;
  padding-right: 30px;
  background-color: #f6f6f6;
  border: 1px solid #e8eaed;
  border-radius: 6%;
  margin-bottom: 10px;
}

.invalid-feedback {
  color: red;
  padding-bottom: 15px;
}
.is-invalid {
  border: 1px solid red !important;
}
.is-valid {
  border: 1px solid green !important;
}
.typo__p {
  color: #349268;
}
.autoComplete {
  padding-right: 40px !important;
}
</style>